import "./App.css";
import Home from "./components/pages/Home";
import SignUp from "./components/pages/Signup";
import About from "./About";
import { Routes, Route } from "react-router-dom";
import SignIn from "./SignIn";
import { AuthProvider, useAuth } from "./components/contexts/AuthContext";
import AuthRoute from "./components/AuthFunctions/AuthRoute";
import AuthRouteIfLoggedOut from "./components/AuthFunctions/AuthRouteIfLoggedOut";
import ForgotPassWordConfirmEmail from "./components/AccountFeatures/ForgotPassWordConfirmEmail";
import Profile from "./components/User/Profile";
import Post from "./components/Media/Post";
import SearchPage from "./components/SearchBar/SearchPage";
import RecipeCategoryAndType from "./components/Media/RecipeCategoryAndType";
import AccountSettingsPage from "./components/User/AccountSettingsPage";
import EmailVerificationPage from "./components/pages/EmailVerficationPage";
import PasswordResetConfirmation from "./components/pages/PasswordResetConfirmationPage";
import PageNotFound from "./components/pages/PageNotFound";
import LogoutPage from "./components/pages/Logout";
import DeactivateAccount from "./components/pages/DeactivateAccountPage";
import ContactPage from "./components/pages/Contact";
import OurVision from "./components/pages/OurVision";
import PrivacyPolicy from "./components/pages/PrivacyPolicyPage";
import AuthAction from "./components/pages/AuthAction";
import AddRecipeSteps from "./components/pages/AddRecipePageSteps/AddRecipeSteps";
import Newsletter from "./components/pages/Newsletter";

import Navbar from "./components/Navbar/Navbar";
import UserSignedIn from "./components/Navbar/UserSignedIn";
import Blog from "./components/pages/Blog/Blog";
import BlogPost from "./components/pages/Blog/BlogPost";
import TermsAndConditions from "./components/TOS/TermsOfConditions";

// Only routes & UI here. The router is provided by:
// - BrowserRouter in src/entry-client.js (client)
// - StaticRouter in your Firebase Function (server)
function AppRoutes() {
  const { currentUser } = useAuth();
  const HeaderNav = currentUser ? (
    <UserSignedIn user={currentUser} />
  ) : (
    <Navbar />
  );

  return (
    <>
      {HeaderNav}

      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/auth/action" element={<AuthAction />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:postId" element={<BlogPost />} />

        {/* Routes for users NOT signed in yet */}
        <Route element={<AuthRoute />}>
          <Route path="/sign_up" element={<SignUp />} />
          <Route path="/login" element={<SignIn />} />
          <Route
            path="/auth/reset-password-request"
            element={<ForgotPassWordConfirmEmail />}
          />
        </Route>

        {/* Routes that require being logged IN */}
        <Route element={<AuthRouteIfLoggedOut />}>
          <Route path="/new_post" element={<AddRecipeSteps />} />
          <Route path="profile/:username" element={<Profile />} />
          <Route
            path="profile/accounts/:edit"
            element={<AccountSettingsPage />}
          />
          <Route
            path="/profile/accounts/deactivate"
            element={<DeactivateAccount />}
          />
        </Route>

        {/* Public routes */}
        <Route path="post/:category/:recipe" element={<Post />} />
        <Route path="/email-verification" element={<EmailVerificationPage />} />
        <Route path="/pages/contact" element={<ContactPage />} />
        <Route path="/pages/about" element={<About />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/pages/our-vision" element={<OurVision />} />
        <Route path="/pages/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/pages/tos" element={<TermsAndConditions />} />
        <Route path="/reset-password" element={<PasswordResetConfirmation />} />
        <Route
          path="explore/:recipe_category/:recipe_type"
          element={<RecipeCategoryAndType />}
        />
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRoutes />
      </div>
    </AuthProvider>
  );
}
